import Vue from 'vue';

import ru from '@/locales/ru';
import { getTextsByPage } from '@/api/customTexts';

interface LocaleMessage {
  [key: string]: string | LocaleMessage;
}
type PairString = [string, string];

function flatMessages(val: LocaleMessage, prefix = ''): PairString[] {
	const arr = Object.entries(val).map(([key, text]) => {
    const val = text;
		return typeof text === 'string' ? [[`${prefix}${key}`, val]] as PairString[]: flatMessages(text, `${prefix}${key}.`)
	});
	const result = ([] as PairString[]).concat(...arr);

  return result;
}

type Locale = 'ru';
const state = Vue.observable<{
	locale: Locale,
	messages: Record<Locale, Map<string, string>>
	loadedPages: Record<Locale,Record<string, boolean>>;
}>({
  locale: 'ru',
  messages: {
    ru: new Map(flatMessages(ru)),
  },
	loadedPages: { ru: {}}
});

export function $t(key: string, params?: Record<string, unknown>) {
  const lang = state.locale;
  const messages = state.messages[lang];
	const result = messages.get(key) ?? key;

  if (typeof result === 'string' && params) {
    return result.replace(/\{(\w+)\}/g, (match, param) => {
      return params[param] !== undefined ? `${params[param]}` : match;
    });
  }
  return result;
}

export function setLocale(lang: Locale) {
  state.locale = lang;
}

export async function loadPageMessages(pageName: string) {
  if (state.loadedPages[state.locale]?.[pageName]) return;
  const messages = state.messages[state.locale];
  try {
    const loaded = await getTextsByPage(pageName);
    const data:PairString[] = Object.entries(loaded).map(([key, val]) => ([`${pageName}.${key}`, val]));
    Vue.set(state.messages, state.locale,  new Map([...messages.entries(), ...data ]));
		Vue.set(state.loadedPages[state.locale], pageName, true);
  } catch (e) {
    console.error(`Не удалось загрузить переводы для "${pageName}"`, e);
  }
}
